import * as React from 'react';

import {
	Alert,
	Button,
	Checkbox,
	Space,
	Typography,
} from 'antd';

import { ErrorMessage } from 'formik';

interface CheckboxConfig {
	text: React.ReactNode;
	checked: boolean;
	onChange: (checked: boolean) => void;
}

interface ActionConfig {
	text: React.ReactNode;
	onClick: () => void;
}

export interface WarningAlertProps {
	isVisible: boolean;
	message: React.ReactNode;
	description: React.ReactNode;
	confirmation?: {
		checkbox?: CheckboxConfig;
		masterCheckbox?: CheckboxConfig;
		action?: ActionConfig;
	};
	validationMessage?: {
		name: string;
	}
}

const ValidationMessage = ({ name }: { name: string }) => (
	<ErrorMessage
		name={name}
		render={(message) => (
			<Typography.Text className="validation-message" type="danger">
				{message}
			</Typography.Text>
		)}
	/>
);

export const WarningAlert = ({
	isVisible, message, description, confirmation, validationMessage,
}: WarningAlertProps) => {
	if (!isVisible) return null;

	const { checkbox, masterCheckbox, action } = confirmation || {};

	return (
		<Alert
			type="warning"
			message={message}
			style={{ marginBottom: 16 }}
			description={(
				<Space direction="vertical" size={8}>
					<p className="pet-warning-confirmation__label">
						{description}
					</p>

					{checkbox && (
						<Checkbox
							checked={checkbox.checked}
							onChange={(e) => checkbox.onChange(e.target.checked)}
						>
							{checkbox.text}
						</Checkbox>
					)}

					{masterCheckbox && (
						<Checkbox
							checked={masterCheckbox.checked}
							onChange={(e) => masterCheckbox.onChange(e.target.checked)}
						>
							{masterCheckbox.text}
						</Checkbox>
					)}

					{action && (
						<Button type="primary" size="small" onClick={action.onClick}>
							{action.text}
						</Button>
					)}

					{validationMessage ? <ValidationMessage name={validationMessage.name} /> : null}
				</Space>
			)}
		/>
	);
};
